import styled from "styled-components";
import { device } from "../../services/styles";

export const Container = styled.article`
  width: 100%;
  max-width: 820px;
  padding: ${(props) =>
    props.addShadow ? "20px 10px 40px 10px" : "0px 10px 0 10px"};
  box-shadow: ${(props) =>
    props.addShadow ? "0px 10px 20px #0000001E" : "none"};
  margin: ${(props) => (props.addShadow ? "40px 0 50px 0" : "0 0 50px 0")};
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: 1000ms;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  @media ${device.tabletLarge} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const MainImage = styled.img`
  width: 100%;
`;
export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  max-height: 400px;
  overflow: hidden;
  margin: 16px auto 20px auto;
  @media ${device.tablet} {
    max-height: 400px;
  }
`;

export const Lead = styled.h3`
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  margin: 0 0 20px 0;
`;

export const ArticleContent = styled.div`
  position: relative;
  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 180px;
    bottom: 0;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 34%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

export const WhiteLink = styled.a`
  color: #fff;
  display: inline-block;
  z-index: 10;
  margin: -40px auto 0 auto;
`;

export const SitesLabel = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 4px;
  right: 4px;
  width: 64px;
  height: 32px;
  padding: 3px;
  background-color: #fff;
`;

export const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
